
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/thank-you-for-downloading-our-salary-survey",
      function () {
        return require("private-next-pages/blog/thank-you-for-downloading-our-salary-survey/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/thank-you-for-downloading-our-salary-survey"])
      });
    }
  